(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["larana-bundle-items"] && !Shopify.designMode) return;
  try {
    
  (function(){
    document.querySelectorAll('.larana-bundle').forEach(function(section){
      var productId = section.dataset.productId;
      var sectionId = section.dataset.sectionId;
      var modal = document.getElementById('lb-modal-' + sectionId);

      /* ── SWATCH-VAL: klicka Instants radio-knapp för rätt option-värde ── */
      section.querySelectorAll('.lb-swatches').forEach(function(row){
        var optionIdx = parseInt(row.dataset.optionIndex, 10);
        var optionName = row.dataset.optionName;
        var label = row.parentElement.querySelector('.lb-selected-label');
        row.querySelectorAll('.lb-sw').forEach(function(sw){
          sw.addEventListener('click', function(){
            var value = sw.dataset.value;
            row.querySelectorAll('.lb-sw').forEach(function(x){ x.classList.remove('is-active'); });
            sw.classList.add('is-active');
            if(label) label.textContent = value;
            updateBundleVariant(optionName, value);
          });
        });
      });

      function updateBundleVariant(optionName, value){
        /* Strategi 1: Instants native VARIANT_PICKER med radio-knappar
           Letar efter radio med name som slutar på __<optionName> och value === valt värde */
        var pickers = document.querySelectorAll('[data-instant-type="VARIANT_PICKER"]');
        var triggered = false;
        pickers.forEach(function(picker){
          var radio = picker.querySelector(
            'input[type="radio"][name$="__' + optionName + '"][value="' + value.replace(/"/g, '\\"') + '"]'
          );
          if(radio && !radio.checked){
            /* Klicka — triggar Instants onclick-handler som uppdaterar state */
            radio.click();
            triggered = true;
          } else if(radio && radio.checked){
            triggered = true;
          }
        });

        /* Strategi 2 (fallback): vanlig Shopify-form om Instant inte finns */
        if(!triggered){
          var forms = document.querySelectorAll('form[action*="/cart/add"]');
          forms.forEach(function(form){
            var radios = form.querySelectorAll('input[type="radio"][name^="options"]');
            radios.forEach(function(r){
              if(r.value === value){
                r.checked = true;
                r.dispatchEvent(new Event('change', {bubbles:true}));
              }
            });
          });
        }

        document.dispatchEvent(new CustomEvent('larana:bundle:variant-changed', {
          detail: { optionName: optionName, value: value, sectionId: sectionId }
        }));
      }

      /* ── SNEAKPEEK-MODAL ── */
      section.querySelectorAll('.lb-peek').forEach(function(btn){
        btn.addEventListener('click', function(){ openModal(btn.dataset.productHandle); });
      });

      function openModal(handle){
        if(!handle || !modal) return;
        /* Hämta produktens data via Shopifys publika .json-endpoint */
        fetch('/products/' + handle + '.js')
          .then(function(r){ return r.json(); })
          .then(function(p){ renderModal(p); })
          .catch(function(){
            renderModal({ title: 'Kunde inte ladda produkten', description: '', images: [] });
          });
      }

      function renderModal(p){
        var titleEl = modal.querySelector('.lb-modal-title');
        var descEl  = modal.querySelector('.lb-modal-desc');
        var galleryEl = modal.querySelector('.lb-modal-gallery');

        titleEl.textContent = p.title || '';
        descEl.innerHTML = p.description || '';

        /* Bygg galleri: huvudbild + thumbnails */
        var imgs = (p.images || []).slice(0, 6);
        if(imgs.length === 0 && p.featured_image){ imgs = [p.featured_image]; }
        if(imgs.length === 0){ galleryEl.innerHTML = ''; }
        else{
          var main = '<div class="main"><img src="' + imgs[0] + '" alt=""></div>';
          var thumbs = '';
          if(imgs.length > 1){
            thumbs = '<div class="thumbs">' + imgs.map(function(src, i){
              return '<img src="' + src + '" data-full="' + src + '"' + (i === 0 ? ' class="is-active"' : '') + ' alt="">';
            }).join('') + '</div>';
          }
          galleryEl.innerHTML = main + thumbs;
          /* Klick på thumbnail byter huvudbild */
          galleryEl.querySelectorAll('.thumbs img').forEach(function(t){
            t.addEventListener('click', function(){
              galleryEl.querySelector('.main img').src = t.dataset.full;
              galleryEl.querySelectorAll('.thumbs img').forEach(function(x){ x.classList.remove('is-active'); });
              t.classList.add('is-active');
            });
          });
        }

        modal.hidden = false;
        document.body.style.overflow = 'hidden';
      }

      function closeModal(){
        if(!modal) return;
        modal.hidden = true;
        document.body.style.overflow = '';
      }

      if(modal){
        modal.querySelectorAll('[data-close]').forEach(function(el){
          el.addEventListener('click', closeModal);
        });
        document.addEventListener('keydown', function(e){
          if(!modal.hidden && e.key === 'Escape') closeModal();
        });
      }
    });

    /* ── TELEPORT (med MutationObserver för late-rendered builders som Instant) ── */
    document.querySelectorAll('.larana-bundle[data-teleport-target]').forEach(function(s){
      var target = s.getAttribute('data-teleport-target');
      if(!target) return;

      function tryTeleport(){
        var placeholder = document.getElementById(target);
        if(placeholder && placeholder !== s.parentNode){
          placeholder.parentNode.insertBefore(s, placeholder);
          placeholder.remove();
          return true;
        }
        return false;
      }

      /* Försök direkt — om Instant redan renderat färdigt */
      if(tryTeleport()) return;

      /* Annars: vänta på att placeholdern dyker upp i DOM:en */
      var observer = new MutationObserver(function(){
        if(tryTeleport()){
          observer.disconnect();
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });

      /* Säkerhetsnät: sluta lyssna efter 10 sekunder oavsett */
      setTimeout(function(){ observer.disconnect(); }, 10000);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["larana-socialproof1"] && !Shopify.designMode) return;
  try {
    
  (function(){
    /* sektions-id används som scope för flera instanser på samma sida */
    document.querySelectorAll('.larana-sp').forEach(function(section){

      var track = section.querySelector('.vs-track');
      if(!track) return;

      var cards = Array.prototype.slice.call(track.querySelectorAll('.vs-card'));
      var N = cards.length;
      if(N === 0) return;

      var dots = section.querySelector('.vs-dots');
      var prev = section.querySelector('.vs-arrow.prev');
      var next = section.querySelector('.vs-arrow.next');
      var VISIBLE = 3;
      var current = 0;
      var animating = false;

      /* om vi har fler videor än som syns: klona första VISIBLE i slutet för sömlös loop framåt */
      if(N > VISIBLE){
        for(var i=0; i<VISIBLE; i++){
          var clone = cards[i].cloneNode(true);
          clone.setAttribute('data-clone', '1');
          track.appendChild(clone);
        }
      }

      /* dots */
      if(dots){
        dots.innerHTML = '';
        for(var d=0; d<N; d++){
          var s = document.createElement('span');
          if(d===0) s.className = 'on';
          dots.appendChild(s);
        }
      }

      function step(){
        var card = track.querySelector('.vs-card');
        var gap = parseFloat(getComputedStyle(track).gap) || 14;
        return card.offsetWidth + gap;
      }
      function setPos(idx, animate){
        track.style.transition = animate ? 'transform .5s cubic-bezier(.4,.0,.2,1)' : 'none';
        track.style.transform = 'translateX(' + (-idx * step()) + 'px)';
      }
      function syncDots(){
        if(!dots) return;
        var kids = dots.children;
        for(var k=0; k<kids.length; k++) kids[k].classList.toggle('on', k === current);
      }
      function syncPrevState(){
        if(prev) prev.disabled = (current === 0);
      }

      function goForward(){
        if(animating || N <= VISIBLE) return;
        animating = true;
        var visualIdx = current + 1;
        setPos(visualIdx, true);
        setTimeout(function(){
          current = (current + 1) % N;
          if(visualIdx >= N) setPos(current, false);
          syncDots();
          syncPrevState();
          animating = false;
        }, 510);
      }
      function goBack(){
        if(animating || current === 0) return;
        animating = true;
        current = current - 1;
        setPos(current, true);
        setTimeout(function(){
          syncDots();
          syncPrevState();
          animating = false;
        }, 510);
      }

      if(next) next.addEventListener('click', goForward);
      if(prev) prev.addEventListener('click', goBack);

      /* swipe — fram OCH bakåt (men bakåt stoppar vid 0) */
      var startX = 0, isDown = false;
      track.addEventListener('touchstart', function(e){ startX = e.touches[0].clientX; isDown = true; }, {passive:true});
      track.addEventListener('touchend', function(e){
        if(!isDown) return; isDown = false;
        var dx = e.changedTouches[0].clientX - startX;
        if(dx < -40) goForward();
        else if(dx > 40) goBack();
      });

      requestAnimationFrame(function(){ setPos(0, false); syncPrevState(); });
      window.addEventListener('resize', function(){ setPos(current, false); });

      /* ── lightbox ── */
      var sectionId = section.id.replace('larana-sp-','');
      var lb = document.getElementById('sp-lb-' + sectionId);
      if(!lb) return;
      var lbVideo = lb.querySelector('.lb-video');
      var currentLb = 0;

      function openLb(idx){
        currentLb = idx;
        var c = cards[idx];
        if(!c) return;
        var src = c.dataset.video || '';
        lb.classList.add('on');
        document.body.style.overflow = 'hidden';

        if(src){
          /* sätt src och vänta tills tillräckligt mycket är laddat innan play */
          lbVideo.src = src;
          lbVideo.load();
          var tryPlay = function(){
            var p = lbVideo.play();
            if(p && typeof p.catch === 'function'){
              p.catch(function(err){
                /* autoplay kan blockeras — användaren får då klicka på spelaren */
                console.log('Video autoplay blocked or failed:', err);
              });
            }
          };
          if(lbVideo.readyState >= 2){
            tryPlay();
          } else {
            lbVideo.addEventListener('loadeddata', tryPlay, { once: true });
          }
        }
      }
      function closeLb(){
        lb.classList.remove('on');
        lbVideo.pause();
        lbVideo.removeAttribute('src');
        lbVideo.load();
        document.body.style.overflow = '';
      }
      function navLb(dir){
        currentLb = (currentLb + dir + N) % N;
        openLb(currentLb);
      }

      cards.forEach(function(c){
        c.addEventListener('click', function(){ openLb(parseInt(c.dataset.idx, 10)); });
      });
      /* även klonade kort ska kunna öppna lightbox */
      track.querySelectorAll('.vs-card[data-clone]').forEach(function(clone){
        clone.addEventListener('click', function(){ openLb(parseInt(clone.dataset.idx, 10)); });
      });

      lb.querySelector('.sp-lb-close').addEventListener('click', closeLb);
      lb.querySelector('.sp-lb-arrow.prev').addEventListener('click', function(){ navLb(-1); });
      lb.querySelector('.sp-lb-arrow.next').addEventListener('click', function(){ navLb(1); });
      lb.addEventListener('click', function(e){ if(e.target === lb) closeLb(); });
      document.addEventListener('keydown', function(e){
        if(!lb.classList.contains('on')) return;
        if(e.key === 'Escape') closeLb();
        if(e.key === 'ArrowLeft') navLb(-1);
        if(e.key === 'ArrowRight') navLb(1);
      });

      /* ── count-up + ring fill när stats kommer in i vy ── */
      var stats = section.querySelector('.sp-stats');
      if(!stats) return;
      var fired = false;
      function animateOne(stat){
        var target = parseInt(stat.dataset.target, 10);
        var numEl = stat.querySelector('.num');
        var ringFill = stat.querySelector('.fill');
        var radius = 36;
        var circ = 2 * Math.PI * radius;
        ringFill.setAttribute('stroke-dasharray', '0 ' + circ);
        var duration = 1500;
        var start = performance.now();
        function tick(now){
          var t = Math.min(1, (now - start) / duration);
          var eased = 1 - Math.pow(1 - t, 3);
          numEl.textContent = Math.round(target * eased) + '%';
          /* hela cirkeln fylls — oavsett målprocent */
          ringFill.setAttribute('stroke-dasharray', (circ * eased) + ' ' + circ);
          if(t < 1) requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
      }
      function fire(){
        if(fired) return; fired = true;
        stats.querySelectorAll('.sp-stat').forEach(function(s, i){
          setTimeout(function(){ animateOne(s); }, i * 180);
        });
      }
      if('IntersectionObserver' in window){
        var io = new IntersectionObserver(function(entries){
          entries.forEach(function(e){ if(e.isIntersecting) fire(); });
        }, {threshold:.3});
        io.observe(stats);
      } else { fire(); }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
